module.exports = __webpack_public_path__ + "img/music-work-icon3.a32e1ab1.png";